module.exports = __webpack_public_path__ + "567b5243b65ea1b068bef34eb0da0e4c.pdf";